import {$,$$} from '../core/dom.js';

export function initToolkit({navigation}){
  $$('.need-card').forEach(button=>button.addEventListener('click',()=>navigation.showScreen(button.dataset.route==='start'?'roll':'router')));
  $('#notSure')?.addEventListener('click',()=>navigation.showScreen('router'));
}
